import { ToolCard } from "@/components/ToolCard";
import { Loader2 } from "lucide-react";
import { Tool } from "@/types";

interface ToolsGridProps {
  tools: Tool[];
  isLoading: boolean;
}

export const ToolsGrid = ({ tools, isLoading }: ToolsGridProps) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {tools.map((tool) => (
        <ToolCard 
          key={tool.id} 
          {...tool} 
          compact={false}
        />
      ))}
    </div>
  );
};